import { axiosInstance } from "./config";


export const getAllservices = async () => {
  const res = await axiosInstance.get('/services');
  return res.data;
};

export const createType = async (data) => {
  const res = await axiosInstance.post('/services', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
};
export const toggleServiceStatus = async (id) => {
  const res = await axiosInstance.post(`/services/toggle/${id}`);
  return res.data;
};

export const updateType = async (id, data) => {
  const res = await axiosInstance.post(`/services/${id}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
};

export const deleteType = async (id) => {
  const res = await axiosInstance.delete(`/services/${id}`);
  return res.data;
};
